export default {
  running: false,
  paused: false,
  shuffle: false,
  repeat: "none", // none, track, playlist
  progress: 0,
  preload: 0,
  volume: 50,
  playlist: null
};
